import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from "vuedraggable";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import CustomFieldDefinition from "../data-inputs/custom-field-definition";
import CustomFieldControlButtons from "../control-buttons/custom-field-control-buttons";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "EditFieldsDefinitionsForm",
  components: {
    CustomFieldDefinition,
    CustomFieldControlButtons,
    SimpleButton,
    draggable
  },
  props: {
    customFields: {
      type: Array,
      required: true
    },
    customFieldsDefinitions: {
      type: Object,
      required: true
    },
    pageName: {
      type: String,
      default: "clientProfile"
    },
    allowVisibility: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      deletingWords: {
        clientProfile: {
          container: "board",
          element: this.$tc("global.doorr.clientProfile", 1)
        },
        referrers: {
          container: "brokerage",
          element: this.$tc("global.doorr.referrer", 1)
        }
      }
    };
  },
  computed: {
    validCustomFields: {
      get() {
        var _context;
        return _filterInstanceProperty(_context = this.customFields).call(_context, field => field.id && this.customFieldsDefinitions.byId[field.id]);
      },
      set(value) {
        this.$emit("order", value);
      }
    },
    orphanCustomFields() {
      var _context2;
      return _filterInstanceProperty(_context2 = this.customFields).call(_context2, field => field.id && !this.customFieldsDefinitions.byId[field.id]);
    }
  },
  methods: {
    getFieldDefinition(fieldId) {
      return this.customFieldsDefinitions.byId[fieldId];
    },
    getFieldVisibility(fieldId) {
      return this.getFieldDefinition(fieldId).visibility;
    },
    isSystemField(fieldId) {
      return this.getFieldDefinition(fieldId).classification === "system";
    },
    handleEdit(id) {
      this.$emit("edit", id);
    },
    handleDelete(id, origin) {
      this.$emit("delete", {
        id,
        origin
      });
    },
    handleVisibilityChange(id) {
      this.$emit("visibility", id);
    },
    handleCreate() {
      this.$emit("create");
    },
    handleCancel() {
      this.$emit("cancel");
    },
    getContainerName() {
      return this.deletingWords[this.pageName].container;
    },
    getElementName() {
      return this.deletingWords[this.pageName].element;
    }
  }
});